const validate = values => {
  const errors = {}

  if (!values?.info?.name) {
    errors.info = { ...errors?.info, name: "The name is required!" }
  }

  if (!values?.info?.price) {
    if (parseInt(values?.info?.price) !== 0) {
      errors.info = { ...errors?.info, price: "The price is required!" }
    }
  }

  if (!values?.info?.stripeProduct) {
    errors.info = {
      ...errors?.info,
      stripeProduct: "The stripe product is required!",
    }
  }

  if (!values?.info?.stripePrice) {
    errors.info = {
      ...errors?.info,
      stripePrice: "The price is required!",
    }
  }

  if (values?.access?.tagExpireType && !values?.access?.tagExpireNumber) {
    errors.access = {
      ...errors?.access,
      tagExpireNumber:
        "The tag expire is required if you've selected something for the type",
    }
  }

  if (values?.access?.tagExpireNumber && !values?.access?.tagExpireType) {
    errors.access = {
      ...errors?.access,
      tagExpireType: "The tag expire type is required",
    }
  }

  return errors
}

export default validate
